import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Page from '../../components/Page';
import RequirementTemplateBuilder from '../../components/RequirementTemplateBuilder';
import LoadingSpinner from '../../components/Spinner';
import { globalRequirementTemplateBuilder } from '../../redux/reducer';

function RequirementTemplateBuilderPage() {
  const { selectedTemplateId } = useParams();
  const currentTemplate = useSelector(globalRequirementTemplateBuilder.selectCurrentRequirementTemplate);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!currentTemplate) {
      dispatch(globalRequirementTemplateBuilder.getRequirementTemplate(selectedTemplateId));
    }
  }, []);

  return (
    <Page fixedHeight>
      {currentTemplate
        ? <RequirementTemplateBuilder blueprint={globalRequirementTemplateBuilder} />
        : <LoadingSpinner />}
    </Page>
  );
}

export default RequirementTemplateBuilderPage;
